import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface EscalationAndCaseHandlingForm {
    [key: string]: SingleDynamicField[];
}

export const useEscalationAndCaseHandling = (chatAssistant: ChatAssistant) => {
    const formikEscalationAndCaseHandling =
        useFormik<EscalationAndCaseHandlingForm>({
            initialValues,
            validationSchema,
            onSubmit: console.log,
        });

    useEffect(() => {
        if (chatAssistant) {
            formikEscalationAndCaseHandling.setValues({
                escalationAndCaseHandling:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.escalationAndCaseHandling ??
                    initialValues.escalationAndCaseHandling,
            });
        }
    }, [chatAssistant]);

    return { formikEscalationAndCaseHandling };
};
